export const mandatoryField = 'Champ obligatoire'

export const invalidField = 'Champ incorrect'

export const requireTosValidation = 'Vous devez accepter les conditions d\'utilisation'
